import React, { Component } from 'react';
import ViewHeader from '../../components/ViewHeader';
import ModuleContainer from '../../components/ModuleContainer';
import { FaPencilAlt, FaRegWindowClose, FaArrowLeft, FaPlus, FaTrash, FaPaperPlane } from 'react-icons/fa';
import { connect } from 'react-redux';
import { Image as NativeImage } from 'react-native';
import { pollSelectors, pollOperations } from './state';
import { bindActionCreators } from 'redux';
import FormTemplate from '../../components/FormTemplate';
import { Col, Row, Card, Button, Form, Modal } from 'react-bootstrap';
import {
    IMAGE_SIZE, MODE_ADD, MODE_VIEW, MODE_EDIT, ERROR, SUCCESS, DATE_TIME_FORMAT, NOTIF_SUCCESS, NOTIF_ERROR, ADMIN, ONLINE, FINAL, EMPTY_STRING,
    POLL_IMAGE, SEND_ONLINE_RESULT, SEND_FINAL_RESULT, SECONDARY, CANCEL, SUCCESS_BUTTON, SAVE, POLLTYPEID_NUMBER, BACK, PRIMARY, UPDATE, DANGER, DELETE,
    POLL_DETAILS, MAXIMUM_NUMBER_OF_ANSWERS, MAXIMUM_NEMBER_OF_CANDIDATES, NO, YES, ENTER_EMAIL_ADDRESS, QUESTION, POSITION, RESULT_AS_OF
} from '../../../utils/constants';
import { isNullOrUndefined } from 'util';
import { POLLS_ROUTE, VIEW_POLL_ROUTE } from './routes';
import moment from 'moment';
import { REST_SERVICE_URL_ROOT } from '../../../config/settings';
import ConfirmationModal from '../../components/ConfirmationModal';
import { SideNotification, isStringEmptyOrNull, isValidImageType, recordImageStyle } from '../../../utils/common';
import {
    MSG_DEFAULT_ERROR, MSG_ONLINE_VOTES_SENT_EMAIL, MSG_FINAL_VOTES_SENT_EMAIL, POLL_IMAGE_REQUIRED, IMAGE_SIZE_MESSAGE, MSG_INVALID_EMAIL, RECOMMENDED_SIZE_700, MSG_EMPTY_REQUIRED,
    SAVE_CHANGES, MSG_CONFIRM_CHANGES, DELETE_MESSAGE, DELETE_POLL, MSG_INVALID_IMAGE_TYPE
} from '../../../utils/messages';
import PollSelection from './PollSelection';
import PollSelectionElection from './PollSelectionElection';
import PollSelectionResult from './PollSelectionResult';
import PollSelectionElectionResult from './PollElectionResult';
import ResultAnnouncementComponent from './ResultAnnouncementComponent';
import debounce from 'lodash.debounce';

class ViewPoll extends Component {

    constructor(props) {
        super(props);
        this.state = {
            imageFile: null,
            pollId: 0,
            mode: MODE_ADD,
            initialPollDetails: null,
            imageHash: Date.now(),
            imageError: false,
            showSaveModal: false,
            pollDetails: null,
            title: '',
            numberOfQuestions: '',
            question: '',
            pollSelections: [],
            donePoll: false,
            onGoingPoll: false,
            showDeleteModal: false,
            imageFileUrl: null,
            questionErrorFlag: null,
            numberOfChoicesFlag: null,
            openModal: false,
            emailModalTitle: '',
            email: '',
            emailErrors: '',
            resultType: '',
            imageErrorSize: false
        }
        //Required to make submission possible on external button
        this.storeForm = null;
        this.resetForm = null;
        this.saveChanges = debounce(this.saveChanges.bind(this), 500);
        this.saveSelection = debounce(this.saveSelection.bind(this), 500);
        this.deletePoll = debounce(this.deletePoll.bind(this), 500);
        this.send = debounce(this.send.bind(this), 500);

    }

    componentDidMount() {
        let id = this.props.match.params.id;

        if (undefined === id) {
            this.setState({ mode: MODE_ADD })
        } else {
            let type = isNullOrUndefined(this.props.location.state) ? MODE_VIEW : this.props.location.state.type;
            this.setState({ pollId: id, mode: type }, () => {

                this.props.getPollById(this.state.pollId)
                    .then((response) => {
                        if (ERROR === response.status) {
                            SideNotification(NOTIF_ERROR, response.message)
                            this.props.history.push(POLLS_ROUTE)

                        } else {
                            let currentUser = this.props.isAuthenticated
                            let poll = response.data.pollDetails;
                            let now = moment().format(DATE_TIME_FORMAT)
                            poll.startDate = moment(poll.pollStartDate).format(DATE_TIME_FORMAT);
                            poll.endDate = moment(poll.pollEndDate).format(DATE_TIME_FORMAT);
                            if (moment(now).isBetween(poll.startDate, poll.endDate) && 1 === currentUser.credentials.accessRights) {
                                this.setState({
                                    onGoingPoll: true
                                })
                            }
                            else {
                                this.setState({
                                    onGoingPoll: false
                                })
                            }
                            if (moment(now).isAfter(poll.endDate)) {
                                this.setState({
                                    donePoll: true
                                })
                            }

                            this.setState({ initialPollDetails: { PollModel: response.data.pollDetails }, pollSelections: response.data.pollSelections })

                            let pollDetails = response.data.pollDetails;
                            if (moment(now).isAfter(pollDetails.pollEndDate)) {
                                this.props.getPollResult(this.state.pollId)
                                    .then((response) => {
                                        if (ERROR === response.status) {
                                            SideNotification(NOTIF_ERROR, response.message)
                                        } else {
                                            let currentUser = this.props.isAuthenticated
                                            let poll = response.data.pollDetails;
                                            let now = moment().format(DATE_TIME_FORMAT)
                                            poll.startDate = moment(poll.pollStartDate).format(DATE_TIME_FORMAT);
                                            poll.endDate = moment(poll.pollEndDate).format(DATE_TIME_FORMAT);

                                            if (moment(now).isBetween(poll.startDate, poll.endDate) && currentUser.credentials.accessRights === 1) {
                                                this.setState({
                                                    onGoingPoll: true
                                                })
                                            }
                                            else {
                                                this.setState({
                                                    onGoingPoll: false
                                                })
                                            }
                                            if (moment(now).isAfter(poll.endDate)) {
                                                this.setState({
                                                    donePoll: true
                                                })
                                            }

                                            this.setState({ initialPollDetails: { PollModel: response.data.pollDetails }, pollDetails: poll })
                                        }
                                    })
                                    .catch(() => SideNotification(NOTIF_ERROR, MSG_DEFAULT_ERROR))
                            }
                        }
                    })
                    .catch(() => SideNotification(NOTIF_ERROR, MSG_DEFAULT_ERROR))
            })
        }
    }

    componentWillReceiveProps(newProps) {
        this.setState({
            pollSelections: isNullOrUndefined(newProps.poll) ? this.state.pollSelections : newProps.poll.pollSelections
        })
    }

    handleSubmit = (values) => {

        let newPoll = values.PollModel;
        newPoll.pollStartDate = moment(newPoll.startDate);
        newPoll.pollEndDate = moment(newPoll.endDate);

        if (isNullOrUndefined(this.state.imageFile) && MODE_ADD === this.state.mode) {
            this.setState({ imageError: true })
        } else {
            this.setState({ imageError: false, imageErrorSize: false, pollDetails: values }, () => this.toggleSave());
        }
    }

    toggleSave = () => {
        this.setState(prevState => ({ showSaveModal: !prevState.showSaveModal }));
    }

    saveChanges = () => {
        let values = this.state.pollDetails;

        if (MODE_EDIT === this.state.mode) {
            let data = values.PollModel
            let params = {
                "pollTitle": data.pollTitle,
                "pollDescription": data.pollDescription,
                "pollId": data.pollId,
                "pollStartDate": data.pollStartDate,
                "pollEndDate": data.pollEndDate,
            }
            this.props.updatePoll(params, this.state.imageFile)
                .then(result => {
                    if (SUCCESS === result.status) {
                        this.setState({ mode: MODE_VIEW, showSaveModal: false, initialPollDetails: { PollModel: values.PollModel } })
                        SideNotification(NOTIF_SUCCESS, result.message);
                    } else {
                        SideNotification(NOTIF_ERROR, result.message);
                    }
                })
                .catch(() => SideNotification(NOTIF_ERROR, MSG_DEFAULT_ERROR))
        } else {
            this.props.insertPoll(values.PollModel, this.state.imageFile)
                .then(result => {
                    if (SUCCESS === result.status) {
                        SideNotification(NOTIF_SUCCESS, result.message);
                        this.props.history.push({ pathname: VIEW_POLL_ROUTE + `/${result.data}`, state: { type: MODE_VIEW } });
                    } else {
                        SideNotification(NOTIF_ERROR, result.message);
                    }
                })
                .catch(() => SideNotification(NOTIF_ERROR, MSG_DEFAULT_ERROR))
        }
    }

    handleImageFile = (event) => {
        if (isNullOrUndefined(event.target.files[0]) || isValidImageType(event.target.files[0])) {
            if (!isNullOrUndefined(event.target.files[0]) && Number(IMAGE_SIZE) < event.target.files[0].size) {
                this.setState({ imageErrorSize: Number(IMAGE_SIZE) < Number(event.target.files[0].size), imageError: false, imageFile: null })
            }

            else {
                this.setState({ imageFile: event.target.files[0], imageErrorSize: false, imageFileUrl: isNullOrUndefined(event.target.files[0]) ? null : URL.createObjectURL(event.target.files[0]) }, () => {
                    MODE_ADD === this.state.mode && this.setState({ imageError: isNullOrUndefined(this.state.imageFile) })
                })
            }
        } else {
            SideNotification(NOTIF_ERROR, MSG_INVALID_IMAGE_TYPE);
        }
    }

    bindSubmitFormik = (submitForm, resetForm) => {
        this.submitForm = submitForm;
        this.resetForm = resetForm;
    };

    updateFormRef = (newForm) => {
        this.form = newForm;
    }

    onSubmitClick = () => {

        this.form.submitForm();
        if (MODE_ADD === this.state.mode) {
            this.setState({ imageError: isNullOrUndefined(this.state.imageFile) })
        }
    }

    onCancelClick = () => {

        if (!isNullOrUndefined(this.state.initialPollDetails)) {
            
            this.form.resetForm(this.state.initialPollDetails);
        }

        this.updateMode(MODE_VIEW);
    }

    updateMode = (mode) => {
        if (null !== this.state.initialPollDetails) {
            this.setState({ mode });
        }
    }

    handleInputChange = (event) => {
        if ("question" === event.target.name) {
            if (EMPTY_STRING === event.target.value.trim()) {
                this.setState({
                    questionErrorFlag: true
                })
            }
            else {
                this.setState({
                    questionErrorFlag: false
                })
            }
        }
        else if ("numberOfQuestions" === event.target.name) {
            if (EMPTY_STRING === event.target.value.trim()) {
                this.setState({
                    numberOfChoicesFlag: true
                })
            }
            else {
                this.setState({
                    numberOfChoicesFlag: false
                })
            }
        }
        this.setState({ [event.target.name]: event.target.value });
    }

    saveSelection = () => {
        let params = {
            pollId: this.state.pollId,
            selectionTitle: this.state.question,
            numChoices: this.state.numberOfQuestions
        }

        this.props.insertPollSelection(params)
            .then(result => {
                if (SUCCESS === result.status) {
                    SideNotification(NOTIF_SUCCESS, result.message);
                    this.setState({
                        numberOfQuestions: EMPTY_STRING,
                        question: EMPTY_STRING
                    })
                } else {
                    SideNotification(NOTIF_ERROR, result.message);
                }
            })
            .catch(() => SideNotification(NOTIF_ERROR, MSG_DEFAULT_ERROR))
    }

    isViewMode = () => {
        return MODE_VIEW === this.state.mode;
    }


    uploadImageContainer = () => {
        return (
            <React.Fragment>
                <center><label><b className={this.isViewMode() ? EMPTY_STRING : "required-input"}>{POLL_IMAGE}</b></label><br /></center>
                <Col className="flex-align">
                    <NativeImage
                        source={{ uri: (isNullOrUndefined(this.state.imageFile) ? `${REST_SERVICE_URL_ROOT}/poll/image/${this.state.pollId}?${this.state.imageHash}` : this.state.imageFileUrl) }}
                        style={recordImageStyle}
                        resizeMode={(MODE_ADD === this.state.mode && isNullOrUndefined(this.state.imageFile)) ? "contain" : "cover"}
                    />
                </Col>
                <br />
                {MODE_VIEW !== this.state.mode && !this.state.onGoingPoll && !this.state.donePoll && (
                    <div className="flex-align">
                        <div>
                            {this.state.imageError && <><label className="formik-error">{POLL_IMAGE_REQUIRED}</label><br /></>}
                            {this.state.imageErrorSize && <><label className="formik-error">{IMAGE_SIZE_MESSAGE}</label><br /></>}
                            <input type='file' className="poll-image" id='photo' accept='image/*' onChange={this.handleImageFile} /> <br />
                            <b>{RECOMMENDED_SIZE_700}</b>
                        </div>
                    </div>
                )}
            </React.Fragment>

        );
    }

    toggleDelete = () => {
        this.setState({
            showDeleteModal: !this.state.showDeleteModal
        })
    }

    deletePoll = () => {
        this.props.deletePoll(this.state.pollId)
            .then((result) => {
                if (SUCCESS === result.status) {
                    SideNotification(NOTIF_SUCCESS, result.message);
                    this.props.history.push(POLLS_ROUTE)
                } else {
                    SideNotification(NOTIF_ERROR, result.message);
                }
                this.toggleDelete();
            });
    }

    sendOnlineResult = () => {
        this.setState({
            openModal: !this.state.openModal,
            emailModalTitle: SEND_ONLINE_RESULT,
            resultType: ONLINE
        })
    }

    sendFinalResult = () => {
        this.setState({
            openModal: !this.state.openModal,
            emailModalTitle: SEND_FINAL_RESULT,
            resultType: FINAL
        })
    }

    toggleEmailModal = () => {
        this.setState({
            openModal: !this.state.openModal,
            emailModalTitle: EMPTY_STRING,
            email: EMPTY_STRING,
            emailErrors: EMPTY_STRING,
            resultType: EMPTY_STRING
        })
    }

    send = () => {
        if (ONLINE === this.state.resultType) {
            this.props.sendOnlineResult(this.state.email, this.state.pollId)
                .then(result => {
                    if (SUCCESS === result.status) {
                        SideNotification(NOTIF_SUCCESS, MSG_ONLINE_VOTES_SENT_EMAIL);
                        this.setState({
                            openModal: false,
                            emailModalTitle: EMPTY_STRING,
                            email: EMPTY_STRING,
                            emailErrors: EMPTY_STRING,
                            resultType: EMPTY_STRING
                        })
                    } else {
                        SideNotification(NOTIF_ERROR, result.message);
                    }
                })
                .catch(() => SideNotification(NOTIF_ERROR, MSG_DEFAULT_ERROR))
        } else {
            this.props.sendFinalResult(this.state.email, this.state.pollId)
                .then(result => {
                    if (SUCCESS === result.status) {
                        SideNotification(NOTIF_SUCCESS, MSG_FINAL_VOTES_SENT_EMAIL);
                        this.setState({
                            openModal: false,
                            emailModalTitle: EMPTY_STRING,
                            email: EMPTY_STRING,
                            emailErrors: EMPTY_STRING,
                            resultType: EMPTY_STRING
                        })
                    } else {
                        SideNotification(NOTIF_ERROR, result.message);
                    }
                })
                .catch(() => SideNotification(NOTIF_ERROR, MSG_DEFAULT_ERROR))
        }
    }

    validateSend() {
        return 0 < this.state.email.length && '' === this.state.emailErrors;
    }

    handleChange = (event) => {

        if (!event.target.value.match(/^\w+([-.]?\w+)*@\w+([-.]?\w+)*(\.\w{2,3})+$/)) {
            this.setState({ emailErrors: [MSG_INVALID_EMAIL] })
        }
        else {
            this.setState({ emailErrors: EMPTY_STRING })
        }
        this.setState({
            [event.target.name]: event.target.value
        });

    }



    renderRightButtons = () => {

        let currentUser = this.props.isAuthenticated.credentials
        let pollTypeId = !isNullOrUndefined(this.state.initialPollDetails) && this.state.initialPollDetails.PollModel.pollTypeId
        let pollDetails = !isNullOrUndefined(this.state.initialPollDetails) && this.state.initialPollDetails.PollModel
        let now = moment().format(DATE_TIME_FORMAT)

        switch (this.state.mode) {

            case MODE_ADD: {
                return [
                    { variant: SECONDARY, label: CANCEL, icon: FaRegWindowClose, onClick: () => this.props.history.push(POLLS_ROUTE) },
                    { variant: SUCCESS_BUTTON, label: SAVE, icon: FaPencilAlt, onClick: this.onSubmitClick }
                ]
            }
            case MODE_EDIT: {

                if (POLLTYPEID_NUMBER === pollTypeId) {

                    if (moment(now).isBetween(pollDetails.pollStartDate, pollDetails.pollEndDate) && ADMIN === currentUser.accessRights) {
                        return (
                            [
                                { variant: SECONDARY, label: BACK, icon: FaArrowLeft, onClick: () => this.props.history.push(POLLS_ROUTE) }
                            ]
                        )
                    }
                    else if (moment(now).isAfter(pollDetails.pollEndDate)) {
                        return (
                            [
                                { variant: SECONDARY, label: BACK, icon: FaArrowLeft, onClick: () => this.props.history.push(POLLS_ROUTE) }
                            ]
                        )
                    }
                    else {
                        return [
                            { variant: SECONDARY, label: CANCEL, icon: FaRegWindowClose, onClick: this.onCancelClick },
                            { variant: SUCCESS_BUTTON, label: SAVE, icon: FaPencilAlt, onClick: this.onSubmitClick }
                        ]
                    }
                }
                else {
                    if (moment(now).isBetween(pollDetails.pollStartDate, pollDetails.pollEndDate) && ADMIN !== currentUser.accessRights) {
                        return [
                            { variant: SECONDARY, label: CANCEL, icon: FaRegWindowClose, onClick: this.onCancelClick },
                            { variant: SUCCESS_BUTTON, label: SAVE, icon: FaPencilAlt, onClick: this.onSubmitClick }
                        ]
                    }
                    else if (moment(now).isBefore(pollDetails.pollStartDate)) {
                        return [
                            { variant: SECONDARY, label: CANCEL, icon: FaRegWindowClose, onClick: this.onCancelClick },
                            { variant: SUCCESS_BUTTON, label: SAVE, icon: FaPencilAlt, onClick: this.onSubmitClick }
                        ]
                    }
                    else if (moment(now).isAfter(pollDetails.pollEndDate) && ADMIN === currentUser.accessRights) {
                        return (
                            [
                                { variant: SECONDARY, label: BACK, icon: FaArrowLeft, onClick: () => this.props.history.push(POLLS_ROUTE) }
                            ]
                        )
                    }
                    else if (moment(now).isAfter(pollDetails.pollEndDate) && ADMIN !== currentUser.accessRights) {
                        return (
                            [
                                { variant: SECONDARY, label: BACK, icon: FaArrowLeft, onClick: () => this.props.history.push(POLLS_ROUTE) },
                                { variant: PRIMARY, label: SEND_ONLINE_RESULT, icon: FaPaperPlane, onClick: () => this.sendOnlineResult() },
                                { variant: PRIMARY, label: SEND_FINAL_RESULT, icon: FaPaperPlane, onClick: () => this.sendFinalResult() }
                            ]
                        )
                    }
                    else if (moment(now).isBetween(pollDetails.pollStartDate, pollDetails.pollEndDate) && ADMIN === currentUser.accessRights) {
                        return (
                            [
                                { variant: SECONDARY, label: BACK, icon: FaArrowLeft, onClick: () => this.props.history.push(POLLS_ROUTE) }
                            ]
                        )
                    }
                    else {
                        return [
                            { variant: SECONDARY, label: CANCEL, icon: FaRegWindowClose, onClick: this.onCancelClick },
                            { variant: SUCCESS_BUTTON, label: SAVE, icon: FaPencilAlt, onClick: this.onSubmitClick }
                        ]
                    }
                }

            }

            default: {

                if (POLLTYPEID_NUMBER === pollTypeId) {

                    if (moment(now).isBetween(pollDetails.pollStartDate, pollDetails.pollEndDate) && ADMIN === currentUser.accessRights) {
                        return (
                            [
                                { variant: SECONDARY, label: BACK, icon: FaArrowLeft, onClick: () => this.props.history.push(POLLS_ROUTE) }
                            ]
                        )
                    }
                    else if (moment(now).isAfter(pollDetails.pollEndDate)) {
                        return (
                            [
                                { variant: SECONDARY, label: BACK, icon: FaArrowLeft, onClick: () => this.props.history.push(POLLS_ROUTE) }
                            ]
                        )
                    }
                    else {
                        return (
                            [
                                { variant: SECONDARY, label: BACK, icon: FaArrowLeft, onClick: () => this.props.history.push(POLLS_ROUTE) },
                                { variant: PRIMARY, label: UPDATE, icon: FaPencilAlt, onClick: () => this.updateMode(MODE_EDIT) },
                                { variant: DANGER, label: DELETE, icon: FaTrash, onClick: () => this.toggleDelete() },
                            ]
                        )
                    }
                }
                else {
                    if (moment(now).isBetween(pollDetails.pollStartDate, pollDetails.pollEndDate) && ADMIN !== currentUser.accessRights) {
                        return (
                            [
                                { variant: SECONDARY, label: BACK, icon: FaArrowLeft, onClick: () => this.props.history.push(POLLS_ROUTE) },
                                { variant: PRIMARY, label: UPDATE, icon: FaPencilAlt, onClick: () => this.updateMode(MODE_EDIT) },
                                { variant: DANGER, label: DELETE, icon: FaTrash, onClick: () => this.toggleDelete() },
                            ]
                        )
                    }
                    else if (moment(now).isBefore(pollDetails.pollStartDate)) {
                        return (
                            [
                                { variant: SECONDARY, label: BACK, icon: FaArrowLeft, onClick: () => this.props.history.push(POLLS_ROUTE) },
                                { variant: PRIMARY, label: UPDATE, icon: FaPencilAlt, onClick: () => this.updateMode(MODE_EDIT) },
                                { variant: DANGER, label: DELETE, icon: FaTrash, onClick: () => this.toggleDelete() },
                            ]
                        )
                    }
                    else if (moment(now).isAfter(pollDetails.pollEndDate) && ADMIN === currentUser.accessRights) {
                        return (
                            [
                                { variant: SECONDARY, label: BACK, icon: FaArrowLeft, onClick: () => this.props.history.push(POLLS_ROUTE) }
                            ]
                        )
                    }
                    else if (moment(now).isAfter(pollDetails.pollEndDate) && ADMIN !== currentUser.accessRights) {
                        return (
                            [
                                { variant: SECONDARY, label: BACK, icon: FaArrowLeft, onClick: () => this.props.history.push(POLLS_ROUTE) },
                                { variant: PRIMARY, label: SEND_ONLINE_RESULT, icon: FaPaperPlane, onClick: () => this.sendOnlineResult() },
                                { variant: PRIMARY, label: SEND_FINAL_RESULT, icon: FaPaperPlane, onClick: () => this.sendFinalResult() }
                            ]
                        )
                    }
                    else if (moment(now).isBetween(pollDetails.pollStartDate, pollDetails.pollEndDate) && ADMIN === currentUser.accessRights) {
                        return (
                            [
                                { variant: SECONDARY, label: BACK, icon: FaArrowLeft, onClick: () => this.props.history.push(POLLS_ROUTE) }
                            ]
                        )
                    }
                    else {
                        return (
                            [
                                { variant: SECONDARY, label: BACK, icon: FaArrowLeft, onClick: () => this.props.history.push(POLLS_ROUTE) },
                                { variant: PRIMARY, label: UPDATE, icon: FaPencilAlt, onClick: () => this.updateMode(MODE_EDIT) },
                                { variant: DANGER, label: DELETE, icon: FaTrash, onClick: () => this.toggleDelete() },
                            ]
                        )
                    }
                }

            }
        }
    }

    render() {
        let pollTypeId = !isNullOrUndefined(this.state.initialPollDetails) && this.state.initialPollDetails.PollModel.pollTypeId
        let poll = !isNullOrUndefined(this.state.initialPollDetails) && this.state.initialPollDetails.PollModel
        let pollSelection = !isNullOrUndefined(this.state.pollSelections) && this.state.pollSelections
        let now = moment().format(DATE_TIME_FORMAT)
        return (

            <ModuleContainer>
                <ViewHeader
                    title={POLL_DETAILS}
                    rightButtons={this.renderRightButtons()}
                />

                <Row style={{ paddingTop: '30px' }}>
                    <Col md={6} className="flex-align">
                        <div>{this.uploadImageContainer()}</div>
                    </Col>
                    <Col md={6} className="flex-align">
                        <FormTemplate
                            formName="polls"
                            editMode={MODE_ADD !== this.state.mode}
                            readOnly={MODE_VIEW === this.state.mode || this.state.donePoll || this.state.onGoingPoll}
                            initialValues={this.state.initialPollDetails}
                            bindSubmitFormik={this.bindSubmitFormik}
                            formInputs={this.props.pollForm}
                            selectInput={this.props.selectInput}
                            validate={pollSelectors.validateForm}
                            updateFormRef={this.updateFormRef}
                            handleSubmit={this.handleSubmit}
                            pollTypeId={pollTypeId}
                            isDisabled={MODE_VIEW === this.state.mode || this.state.donePoll || this.state.onGoingPoll}
                        />
                    </Col>
                </Row>
                <hr />
                <br />
                {MODE_ADD !== this.state.mode && moment(now).isAfter(poll.pollEndDate) && <ResultAnnouncementComponent />}
                {MODE_ADD !== this.state.mode && 0 < pollSelection.length &&
                    <div>
                        <h2><center><b>{poll.pollTitle}</b></center></h2>
                        <div>
                            <p className="result"><i>{moment(now).isAfter(poll.pollEndDate) && RESULT_AS_OF + moment(poll.updatedAt).format(DATE_TIME_FORMAT)}</i></p>
                        </div>

                    </div>
                }
                {!isNullOrUndefined(poll.pollId) && 0 < poll.pollId && MODE_EDIT === this.state.mode && !this.state.donePoll && !this.state.onGoingPoll &&
                    <div>
                        <h3 style={{ fontWeight: 'bold', textAlign: 'center' }}>{""}</h3>
                        <Card style={{ width: '50%', margin: 'auto', padding: '30px' }}>
                            <Row>
                                <Form style={{ width: '100%' }}>
                                    <Form.Row>
                                        <Col md={4}>
                                            <Form.Label>{POLLTYPEID_NUMBER === pollTypeId ? QUESTION : POSITION}</Form.Label>
                                            <Form.Control name="question" onChange={this.handleInputChange} value={this.state.question} placeholder={1 === pollTypeId ? "Enter question" : "Enter position"} />

                                            {(this.state.questionErrorFlag) &&
                                                (<p className="choice-error">{MSG_EMPTY_REQUIRED}</p>)}
                                        </Col>
                                        <Col md={5}>
                                            <Form.Label>{POLLTYPEID_NUMBER === pollTypeId ? MAXIMUM_NUMBER_OF_ANSWERS : MAXIMUM_NEMBER_OF_CANDIDATES}</Form.Label>
                                            <Form.Control name="numberOfQuestions" type="number" onChange={this.handleInputChange} value={this.state.numberOfQuestions} placeholder="Enter maximum no. of choices" />
                                            {(this.state.numberOfChoicesFlag) &&
                                                (<p className="choice-error">{MSG_EMPTY_REQUIRED}</p>)}
                                        </Col>
                                        <Col md={3} className={this.state.questionErrorFlag || this.state.numberOfChoicesFlag ? 'add-question-withmargin' : 'add-question'}>
                                            <Button disabled={isStringEmptyOrNull(this.state.question) || isStringEmptyOrNull(this.state.numberOfQuestions)} className="add-selection" onClick={() => this.saveSelection()}><FaPlus /> Add {1 === pollTypeId ? 'Question ' : 'Candidate'}</Button>
                                        </Col>
                                    </Form.Row>
                                </Form>
                            </Row>
                        </Card>

                    </div>
                }

                {
                    POLLTYPEID_NUMBER === pollTypeId ?

                        MODE_ADD !== this.state.mode && pollSelection && pollSelection.map((data, idx) => {
                            if (moment(now).isAfter(poll.pollEndDate)) {
                                return (
                                    <div key={idx} >
                                        <PollSelectionResult
                                            selections={data}
                                            pollDetails={poll}
                                            mode={this.state.mode} />
                                    </div>
                                )
                            }
                            else {
                                return (
                                    <div key={idx} >
                                        <PollSelection
                                            selections={data}
                                            pollDetails={poll}
                                            mode={this.state.mode} />
                                    </div>
                                )
                            }
                        })
                        :
                        MODE_ADD !== this.state.mode && pollSelection && pollSelection.map((data, idx) => {
                            if (moment(now).isAfter(poll.pollEndDate)) {
                                return (
                                    <div key={idx}>
                                        <PollSelectionElectionResult
                                            selections={data}
                                            pollDetails={poll}
                                            mode={this.state.mode}
                                            idx={idx}
                                        />
                                    </div>
                                )
                            }
                            else {
                                return (
                                    <div key={idx}>
                                        <PollSelectionElection
                                            selections={data}
                                            pollDetails={poll}
                                            mode={this.state.mode}
                                        />
                                    </div>
                                )
                            }
                        })
                }

                <ConfirmationModal
                    show={this.state.showSaveModal}
                    toggleModal={this.toggleSave}
                    title={SAVE_CHANGES}
                    message={MSG_CONFIRM_CHANGES}
                    modalButtons={[
                        { label: NO, onClick: this.toggleSave, variant: SECONDARY },
                        { label: YES, onClick: this.saveChanges, variant: SUCCESS_BUTTON }
                    ]}
                />

                <ConfirmationModal
                    show={this.state.showDeleteModal}
                    toggleModal={this.toggleDelete}
                    title={DELETE_POLL}
                    message={DELETE_MESSAGE}
                    modalButtons={[
                        { label: NO, onClick: this.toggleDelete, variant: SECONDARY },
                        { label: YES, onClick: this.deletePoll, variant: DANGER }
                    ]}
                />

                <Modal show={this.state.openModal} onHide={this.toggleEmailModal}>
                    <Modal.Header closeButton>
                        <Modal.Title>{this.state.emailModalTitle}</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <Form.Group>
                            <Form.Label>{ENTER_EMAIL_ADDRESS}</Form.Label>
                            <Form.Control placeholder="Enter email address" name="email" type="email" onChange={this.handleChange}>
                            </Form.Control>
                            <p className="email-error">{this.state.emailErrors}</p>
                        </Form.Group>
                        <Button className="btn-send" onClick={() => this.send()} disabled={!this.validateSend()}>Send</Button>
                    </Modal.Body>
                </Modal>


            </ModuleContainer>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        pollForm: state.polls.pollForm,
        selectInput: state.polls.selectInput,
        poll: state.polls.poll,
        isAuthenticated: state.auth,
    }
}

const mapDispatchToProps = (dispatch) => bindActionCreators(
    {
        insertPoll: pollOperations.insertPoll,
        updatePoll: pollOperations.updatePoll,
        getPollById: pollOperations.getPollById,
        insertPollSelection: pollOperations.insertPollSelection,
        deletePoll: pollOperations.deletePoll,
        getPollResult: pollOperations.getPollResult,
        sendOnlineResult: pollOperations.sendOnlineResult,
        sendFinalResult: pollOperations.sendFinalResult
    },
    dispatch
)

export default connect(mapStateToProps, mapDispatchToProps)(ViewPoll);